/**
 * "AI Saint" wordmark with a tilted golden halo hovering above the final "t".
 * Drop in wherever the product name should read as brand copy rather than
 * inline body text — sidebar label, page header, hero mention, etc.
 *
 * Usage:  <AISaintWordmark />                (default gold halo)
 *         <AISaintWordmark className="text-2xl" />
 *         <AISaintWordmark haloClassName="text-white" />
 */
export default function AISaintWordmark({
  className = "",
  haloClassName = "text-gold",
  as: Tag = "span",
}) {
  return (
    <Tag className={`inline-flex items-baseline whitespace-nowrap ${className}`} data-testid="ai-saint-wordmark">
      AI&nbsp;Sain
      <span className="relative inline-block leading-none">
        {/* Tilted halo — sits above the ascender of the "t" */}
        <svg
          className={`absolute left-1/2 -top-[0.7em] pointer-events-none ${haloClassName}`}
          width="1.1em"
          height="0.45em"
          viewBox="0 0 22 9"
          style={{ transform: "translateX(-50%) rotate(-16deg)" }}
          aria-hidden="true"
        >
          <ellipse
            cx="11"
            cy="4.5"
            rx="9"
            ry="2.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            opacity="0.95"
          />
        </svg>
        t
      </span>
    </Tag>
  );
}
